import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { toast } from 'react-toastify';
import { createCompanyCategory, deleteCompanyCategory, getCompanyCategories, updateCompanyCategory } from '../../redux/companyCategory/companyCategorySlice';
import PaginationHelper from '../../helper/PaginationHelper';
const NAME_MAX = 100;
const DESC_MAX = 255;
const CompanyCategoryLayer = () => {

  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state.companyCategory);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [editId, setEditId] = useState(null);

  const [search, setSearch] = useState("");
  const [entries, setEntries] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(getCompanyCategories());
  }, [dispatch]);

  const filtered = categories?.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()) ||
    item.description?.toLowerCase().includes(search.toLowerCase())
  );

  const totalEntries = filtered.length;
  const totalPages = Math.ceil(totalEntries / entries);

  const startIndex = (currentPage - 1) * entries;
  const endIndex = startIndex + entries;
  const paginated = filtered.slice(startIndex, endIndex);

  const handleSubmit = () => {
    if (!name || !name.trim()) {
      toast.error("Name is required");
      return;
    }

    if (name.length > NAME_MAX) {
      toast.error(`Name max ${NAME_MAX} characters`);
      return;
    }

    if (!description || !description.trim()) {
      toast.error("Description is required");
      return;
    }

    if (description.length > DESC_MAX) {
      toast.error(`Description max ${DESC_MAX} characters`);
      return;
    }

    const payload = {
      name: name.trim(),
      description: description.trim(),
    };

    const action = editId
      ? updateCompanyCategory({ id: editId, data: payload })
      : createCompanyCategory(payload);

    dispatch(action)
      .unwrap()
      .then((res) => {
        toast.success(
          res?.message ||
          res?.data?.message ||
          (editId ? "Updated successfully" : "Created successfully")
        );

        dispatch(getCompanyCategories());

        setName("");
        setDescription("");
        setEditId(null);

        document.querySelector("#categoryModal .btn-close")?.click();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong"
        );
      });
  };

  return (
    <>
      <div className="card h-100 p-0 radius-12">

        {/* HEADER */}
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex justify-content-between">

          <div className="d-flex gap-3">
            <select
              className="form-select form-select-sm w-auto"
              value={entries}
              onChange={(e) => setEntries(Number(e.target.value))}
            >
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="150">150</option>
              <option value="200">200</option>
            </select>

            <input
              className="form-control w-auto"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <button
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#categoryModal"
            onClick={() => {
              setName("");
              setDescription("");
              setEditId(null);
            }}
          >
            + Add Category
          </button>

        </div>

        {/* TABLE */}
        <div className="card-body p-12">
          <table className="table bordered-table">

            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Description</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {paginated.map((item, i) => (
                <tr key={item.id}>
                  <td>{startIndex + i + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.description}</td>

                  <td>
                    <button
                      className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                      data-bs-toggle="modal"
                      data-bs-target="#categoryModal"
                      onClick={() => {
                        setName(item.name);
                        setDescription(item.description);
                        setEditId(item.id);
                      }}
                    >
                      <Icon icon="lucide:edit" />
                    </button>

                    {/* <button
                      className="btn btn-sm btn-danger"
                      onClick={() => {
                        dispatch(deleteCompanyCategory(item.id));
                      }}
                    >
                      Delete
                    </button> */}
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
          {/* PAGINATION */}
          <PaginationHelper
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            totalItems={totalEntries}
            pageSize={entries}
          />
        </div>

      </div>

      {/* MODAL */}
      <div className="modal fade" id="categoryModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5>{editId ? "Edit" : "Add"} Category</h5>
              <button className="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <div className="modal-body">

              <label>
                Name <span className="text-danger">*</span>
              </label>
              <input
                className="form-control mb-2"
                placeholder="Enter category name"
                maxLength={100}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />

              <label>
                Description <span className="text-danger">*</span>{" "}
                <small className='fst-italic'>(Max 255 chars)</small>
              </label>
              <textarea
                className="form-control"
                rows={4}
                maxLength={255}
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />

            </div>

            <div className="modal-footer">
              <button className="btn btn-primary" onClick={handleSubmit}>
                Save
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyCategoryLayer;